import React, { useState } from "react";
import { motion } from "framer-motion";
import imgLeft from "../../images/learning_style/s3.png";
import ProgressBarStyle from "../../components/ProgressBarStyle"; 

const Style2 = () => {
  // --- 1. DEKLARASI STATE ---
  const [selected, setSelected] = useState(null); 
  const [loading, setLoading] = useState(false);

  // Mengambil student_id yang benar dari localStorage
  const student = JSON.parse(localStorage.getItem("student"));
  const studentId = student?.student_id;

  // --- VALIDASI SESI AWAL ---
  if (!studentId || Number(studentId) <= 0) {
    alert("Student session error or ID missing. Please log in again.");
    window.location.href = "/login";
    return;
  }

  // --- DEKLARASI OPSI ---
  const options = [
    { key: "S2-Q1", label: "video", preference_id: 6 },
    { key: "S2-Q2", label: "plan showing room/map", preference_id: 7 },
    { key: "S2-Q3", label: "discussion", preference_id: 8 },
  ];

  // --- 2. FUNGSI toggleSelect (Pilihan Tunggal) ---
  const toggleSelect = (key) => {
    setSelected(key);
  };

  // --- FUNGSI SAVE TO DATABASE ---
  const saveToDatabase = async () => {
    setLoading(true);

    try {
      const selectedOption = options.find((o) => o.key === selected);

      if (!selectedOption) {
        throw new new Error("No valid option selected.");
      }

      const selectedPreferences = [selectedOption.preference_id];
      const nextStep = '3'; // Step berikutnya setelah Style 2
      
      const body = {
        student_id: Number(studentId),
        style_id: 2, // Style ID untuk kuesioner ini
        preferences: selectedPreferences,
        next_step: nextStep, // DIKIRIM KE BACKEND untuk update ls_current_step
      };

      const res = await fetch("http://localhost:3000/api/learning-style/save", {
        method: "PUT", 
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      if (!res.ok) {
        alert(data.message || "Error saving data");
        setLoading(false);
        return;
      }

      // --- PERUBAHAN KRUSIAL: UPDATE LOCALSTORAGE ---
      const currentStudent = JSON.parse(localStorage.getItem("student"));
      const updatedStudent = {
        ...currentStudent,
        ls_current_step: data.next_step || nextStep,  
      };
      localStorage.setItem("student", JSON.stringify(updatedStudent));
      // ------------------------------------------------
      
      // Redirect ke kuesioner berikutnya
      window.location.href = "/learning-style/style3";  
      
    } catch (err) {
      console.error(err);
      alert("Failed to save. Try again.");
      setLoading(false);
    }
  };

  // --- FUNGSI handleNext (Validasi Frontend) ---
  const handleNext = () => {
    if (!selected) { 
      alert("Please select one option.");
      return;
    }
    saveToDatabase();
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-b from-blue-900 via-blue-700 to-blue-500 text-white px-4 overflow-hidden">
        
      {/* Progress Bar */}
      <div className="w-full max-w-lg mt-6 z-10">
        <ProgressBarStyle step={2} />  
      </div>
      
      <div className="flex flex-col md:flex-row items-start justify-center gap-0 w-full max-w-4xl relative z-10">

        {/* LEFT IMAGE */}
        <motion.img // Tambahkan motion untuk gambar juga (opsional)
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          src={imgLeft}
          alt="illustration"
          // >>> PERUBAHAN: Tambahkan margin negatif untuk menggeser gambar ke kiri <<<
          // md:-ml-20: Di layar menengah ke atas, geser gambar 5rem ke kiri.
          // md:mr-4: Tambahkan sedikit margin kanan agar konten tidak terlalu rapat.
          className="w-[250px] md:w-[400px] drop-shadow-2xl flex-shrink-0 md:-ml-20 md:mr-4"
        />

        {/* RIGHT CONTENT */}
        <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex flex-col flex-1 z-20 mt-4 md:mt-16" // Tambah mt-16 untuk menyeimbangkan vertikal
        >
          {/* PERUBAHAN: Tambahkan padding kiri di mobile (md:pl-0) */}
          <h1 className="text-lg md:text-xl font-normal text-yellow-300 leading-snug text-left drop-shadow-md pl-4 md:pl-0">
            When studying using materials, I learn best using:
          </h1>

          {/* OPTIONS */}
          {/* PERUBAHAN: Tambahkan padding kiri di mobile (pl-4 md:pl-0) */}
          <div className="mt-4 flex flex-col gap-4 pl-4 md:pl-0"> 
            {options.map((opt) => (
              <motion.div
                key={opt.key}
                whileHover={{ scale: 1.02 }}
                onClick={() => toggleSelect(opt.key)}
                className="flex items-center gap-4 cursor-pointer"
              >
                {/* SELECT CIRCLE */}
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center border-4 ${
                    selected === opt.key 
                      ? "bg-yellow-300 border-yellow-400 text-blue-900"
                      : "border-yellow-300 text-transparent"
                  }`}
                >
                  ✓
                </div>

                {/* TEXT BOX */}
                <div className="flex-1 bg-yellow-300 text-green-900 font-medium text-center py-2 rounded-full text-sm md:text-base shadow-md">
                  {opt.label}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      <motion.button
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleNext}
        disabled={loading}
        className="mt-8 bg-yellow-300 text-blue-900 font-bold px-12 py-3 rounded-full shadow-lg disabled:bg-gray-400"
      >
        {loading ? "Saving..." : "Next →"}
      </motion.button>

      <p className="absolute bottom-3 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Style2;